import React, { useEffect, useState } from 'react'
import { ClientListContainer } from 'components/ClientList/ClientList.styled'
import ClientList from 'components/ClientList'
import FacilityFormTemplate from 'templates/FacilityFormTemplate'
import { useAppDispatch, useAppState } from 'store'
import { clientActions } from 'store/slices/clients/clients.slice'
import { CLIENT_LIST_LIMIT } from 'utils/client-list-constant'
import { ClientListSearchContainer } from './ClientList.styled'
import Spinner from 'components/Spinner'
import { useHistory, useParams } from 'react-router'
import { Location } from 'models/location'
import Select from 'components/Select'
import { SelectTypes } from 'components/Select/Select.props'
import Button from 'components/Button/Button'

const ClientListPage: React.FC = () => {
  const params: Location = useParams()
  const { push } = useHistory()
  const dispatch = useAppDispatch()
  const {
    clients,
    currentPage,
    loading,
    players,
    playersLoading,
  } = useAppState(state => state.clients)
  const searchText = ''
  const [tableLoading, setTableLoading] = useState<boolean>(false)
  const [playerList, setPlayerList] = useState<SelectTypes[]>([])

  useEffect(() => {
    if (loading === 'loading') {
      setTableLoading(true)
    }
    if (loading === 'succeeded') {
      setTableLoading(false)
    }
  }, [loading])

  useEffect(() => {
    (async () => {
      await dispatch(
        clientActions.getClients({
          locationId: params ? params.locationId : '',
          page: currentPage,
          limit: CLIENT_LIST_LIMIT,
          search_text: searchText,
        })
      ).then(async () => {
        await dispatch(
          clientActions.getAllClients({
            locationId: params ? params.locationId : '',
            page: 0,
            limit: CLIENT_LIST_LIMIT,
            search_text: searchText,
          })
        )
      })
    })()
  }, [currentPage])

  useEffect(() => {
    if (players && players.length > 0) {
      const list = players.map(player => {
        return { label: player.title, value: player.id.toString() }
      })
      setPlayerList(list)
    }
  }, [players])

  const searchClients = (text: string) => {
    if (text.length >= 3) {
      dispatch(
        clientActions.getClientPlayers({
          locationId: params ? params.locationId : '',
          page: 0,
          limit: 100,
          search_text: text,
        })
      )
      return
    }
  }

  const handleSelected = async (client: SelectTypes) => {
    if (client) {
      await dispatch(
        clientActions.getClients({
          locationId: params ? params.locationId : '',
          page: currentPage,
          limit: CLIENT_LIST_LIMIT,
          search_text: client.label,
        })
      ).then(async () => {
        await dispatch(
          clientActions.getAllClients({
            locationId: params ? params.locationId : '',
            page: 0,
            limit: CLIENT_LIST_LIMIT,
            search_text: searchText,
          })
        )
      })
    }
  }

  return (
    <FacilityFormTemplate>
      {tableLoading ? (
        <Spinner loading={tableLoading} />
      ) : (
        <ClientListContainer>
          <ClientListSearchContainer>
            <div style={{ width: '50%' }}>
              <Select
                autocomplete
                label="Search"
                options={playerList}
                isLoading={playersLoading === 'loading' ? true : false}
                placeholder="Client name"
                onChange={client => handleSelected(client as SelectTypes)}
                onInputChange={searchClients}
              />
            </div>
            <Button
              text="Create Client"
              variant="primary"
              preset="filled"
              size={'medium'}
              onClick={() =>
                push(`/locations/${params.locationId}/settings/create-clients`)
              }
            />
          </ClientListSearchContainer>
          <ClientList clients={clients} locationId={params.locationId} />
        </ClientListContainer>
      )}
    </FacilityFormTemplate>
  )
}

export default ClientListPage
